import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const DeveloperConsolePage = lazy(() => import("@/features/dashboard/pages/developer-console"));

export const Route = createFileRoute("/(app)/dashboard/developer")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground p-6 text-sm">Loading Developer Console...</div>}>
      <DeveloperConsolePage />
    </Suspense>
  ),
});
